import styled from 'styled-components'

export const CenterContent = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`

export const BorderTop = styled.div`
  border-top: 1px solid #dededf;
  height: 0;
  width: 100%;
  padding: 0;
  margin: 0;
`

export const DividerContainer = styled.div`
  & .divider {
    margin: ${(props) => (props.small ? '2px 0px' : null)};
    margin-top: ${(props) => (props.medium ? '12px' : null)};
    margin-bottom: ${(props) => (props.medium ? '12px' : null)};
  }
`

export const HeaderContainer = styled.div`
  vertical-align: middle;
  display: ${(props) => (props.inline ? 'inline' : null)};

  & .header {
    color: white;
    display: ${(props) => (props.inline ? 'inline' : null)};
  }
`
